import { useState } from 'react';
import { strings } from '@/content/strings';
import { Frame } from '@/ui/Frame';
import { Surface } from '@/ui/Surface';
import { QaPanel } from './QaPanel';
import { useQa } from './recorder';
import { useElapsed } from './useElapsed';
import styles from './QaBadge.module.css';

/**
 * While a QA test session records, a REC badge with the elapsed time stays on every screen, so
 * recording is never hidden. Tapping it opens the session controls (note, stop).
 */
export function QaBadge() {
  const state = useQa();
  const elapsed = useElapsed(state.startedAt);
  const [open, setOpen] = useState(false);
  if (!state.recording && !open) return null;
  return (
    <>
      {state.recording && (
        <button
          type="button"
          className={styles.badge}
          aria-label={strings.qa.recording(elapsed)}
          onClick={() => {
            setOpen(true);
          }}
        >
          <span className={styles.dot} aria-hidden />
          REC {elapsed}
        </button>
      )}
      {open && (
        <div
          className={styles.backdrop}
          role="dialog"
          aria-modal="true"
          aria-label={strings.qa.title}
          onClick={(e) => {
            if (e.target === e.currentTarget) setOpen(false);
          }}
        >
          <div className={styles.panel}>
            <Frame>
              <Surface variant="screen" className={styles.screen}>
                <QaPanel />
                <button
                  type="button"
                  className={styles.close}
                  onClick={() => {
                    setOpen(false);
                  }}
                >
                  {strings.settings.done}
                </button>
              </Surface>
            </Frame>
          </div>
        </div>
      )}
    </>
  );
}
